var refresh = function (column) {
    var $ = jQuery;
    column.$el.find('[data-refresh="column"]').on('change', function () {
        // Allow plugins to hook into this event
        $(document).trigger('AC.column.prerefresh', column.$el);
        column.$el.addClass('loading');
        setTimeout(function () {
            column.refresh().always(function () {
                column.$el.removeClass('loading');
            }).fail(function () {
                column.showMessage(AC.i18n.errors.loading_column);
            });
        }, 200);
    });
};
export default refresh;
